import DocumentMeta from 'core/components/DocumentMeta'
import Tabs from 'core/elements/tabs'
import Tab from 'core/elements/tabs/Tab'
import { routeManager } from 'core/utils/routes'
import useReactRouter from 'use-react-router'
import React, { useEffect } from 'react'
import { IAppsDetailsPageTabs } from '../model'
import MyApps from './app/myApps/MyApps'
import Templates from './templates/Templates'
import AllApps from './app/allApps/AllApps'
import { isAdmin } from 'app/plugins/infrastructure/components/common/helpers'
import { useAppSelector } from 'app/store'
import { allAppSelector, myAppSelector, templateSelector } from '../repositories/selector'
import { isReadonlyUser } from 'core/utils/helpers'

const AppsDetailsPage = () => {
  const { history } = useReactRouter()
  const myApps = useAppSelector(myAppSelector)
  const appDetails = useAppSelector(allAppSelector)
  const templates = useAppSelector(templateSelector)

  useEffect(() => {
    if (isReadonlyUser()) {
      if (location.pathname.includes('apps/myapps')) {
        history.replace(
          routeManager.routes.openstack.appsDetails.details.path({
            tab: IAppsDetailsPageTabs.Allapps,
          }),
        )
      }
    }
  }, [location])

  return (
    <>
      <DocumentMeta title="My Apps" breadcrumbs />
      <Tabs route={routeManager.routes.openstack.appsDetails.details}>
        {!isReadonlyUser() && (
          <Tab label="My Apps" value={IAppsDetailsPageTabs.Myapps} count={myApps?.length || 0}>
            <MyApps />
          </Tab>
        )}
        <Tab label="All Apps" value={IAppsDetailsPageTabs.Allapps} count={appDetails?.length || 0}>
          <AllApps />
        </Tab>
        {isAdmin() && (
          <Tab
            label="Templates"
            value={IAppsDetailsPageTabs.Templates}
            count={templates?.length || 0}
          >
            <Templates />
          </Tab>
        )}
        {/* <Tab label="Approvals" value={IAppsDetailsPageTabs.Approvals}>
          comming soon...
        </Tab> */}
      </Tabs>
    </>
  )
}

export default AppsDetailsPage
